import React, { useContext, useState, useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import { getPendantColor } from '../../utils/color';
import { style } from '../../utils/image';
import RootStore from '../../store/RootStore';
import { ThemeContext } from '../../store/ThemeProvider';
import {INormalButton} from './NormalButton';
import ReactSVG from 'react-svg';
import QRCode from 'qrcode';

const QrcodeView = (props:{
  qrcode:string,
  parent:any,
  onClick:()=>void
})=>{
  const {parent, qrcode} = props;
  const [rect, setRect] = useState({
    top:0,
    left:0
  } as {
    top:number,
    left:number
  });

  useEffect(()=>{
    if(parent && parent.current) {
      let bound = parent.current.getBoundingClientRect();
      if(bound) {
        setRect({
          top:bound.y - 249 - 18,
          left:bound.x
        })
      }
    }
  }, [parent]);

  return createPortal(<div className="mobile-view-modal" style={{...rect}} onClick={props.onClick}>
    <img className="qrcode" src={qrcode} />
    <div className="tooltip">扫一扫 手机上观看</div>
  </div>, window.document.body);
}

const MobileViewButton = (props: INormalButton) => {
  const { backgroundColor, mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  const [qrcode, setQrcode] = useState('');
  const [showQrcode, setShowQrcode] = useState(false);

  useEffect(()=>{
    QRCode.toDataURL(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}`, { margin: 2 }).then((dataUrl:string)=>{
      setQrcode(dataUrl);
    });
  }, []);

  const item = useRef<HTMLDivElement>(null);

  return (
    <div className={`pendant-row ${props.className || ''}`} ref={item}>
      <div
        className="pendent-normal mobile-view-button"
        onClick={()=>{
          setShowQrcode(!showQrcode);
        }}
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor,
          ...props.style
        }}
      >
        <ReactSVG
          src={require("../../svg/mobile.pc.svg")}
          style={{ width: 9, height: 14, margin: "0 auto" }}
        />
        <span>手机看</span>
      </div>
      {showQrcode ? <QrcodeView qrcode={qrcode} parent={item} onClick={()=>setShowQrcode(false)} /> : null}
    </div>
  );
};

export default MobileViewButton;
